import { __exports as a } from "../../../../_virtual/add-matching-cards-to-results.js";
import "./clone.js";
import "./matches.js";
import { __exports as l } from "../../../../_virtual/clone.js";
import { __exports as n } from "../../../../_virtual/matches.js";
Object.defineProperty(a, "__esModule", { value: !0 });
a.addMatchingCardsToResults = void 0;
var d = l, m = n;
function p(o, r, i) {
  var t, e;
  for (t = 0; t < r.patterns.length; t++) {
    var s = r.patterns[t];
    if (m.matches(o, s)) {
      var h = d.clone(r);
      Array.isArray(s) ? e = String(s[0]).length : e = String(s).length, o.length >= e && (h.matchStrength = e), i.push(h);
      break;
    }
  }
}
a.addMatchingCardsToResults = p;
export {
  a as default
};
